export const generateColumns = (
  title: string,
  key: string,
  render: any,
  sorteable = false,
  align = 'left',
  width = '',
  fixed = false as any,
  className = '',
  visible = 'visible' as const,
  type = 'string',
  hideable = true
) => {
  const sorter = sorteable ? () => {} : undefined
  return { title, render, align, dataIndex: key, key, sorter, width, fixed, className, visible, type, hideable }
}
